var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 8H5.34M8 8H8.00667M10.6667 8H10.6733M14 8C14 10.9453 11.3133 13.3333 8 13.3333C7.01909 13.3367 6.04986 13.1205 5.16333 12.7007L2 13.3333L2.93 10.8533C2.34133 10.028 2 9.04933 2 8C2 5.05466 4.68667 2.66666 8 2.66666C11.3133 2.66666 14 5.05466 14 8Z",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatOutline);
export default __webpack_public_path__ + "static/media/ChatOutline.2c7aee14adbaef7b5b3df57de1097b43.svg";
export { ForwardRef as ReactComponent };